const BASE_URL = '/api/organization/'

export const useOrganization = () => {
  const { fetchGet, fetchPost, fetchPostForm } = useCustomFetch()

  function getOrganization(id: string): Promise<Organization> {
    return fetchGet(BASE_URL + id)
  }

  function participate(org: Organization) {
    return fetchPost(BASE_URL + 'participate', org)
  }

  function createProject(proj: Organization): Promise<Organization> {
    proj.type = 'PROJECT'
    proj.aliases = null
    return fetchPost(BASE_URL + 'create-project', proj)
  }

  function updateOrganization(org: Organization): Promise<Organization> {
    return fetchPost(BASE_URL + 'update', org)
  }

  function authorizeOrganization(org: Organization): Promise<Organization> {
    return fetchPost(BASE_URL + org.id + '/authorize')
  }

  function searchOrganization(
    q: SearchQuery,
  ): Promise<SearchResult<Organization>> {
    return fetchGet(BASE_URL + 'search' + toSearchQueryString(q))
  }

  async function searchOrganizationList(
    q: SearchQuery,
  ): Promise<Organization[]> {
    let baseQuery = q
    if (q === null) {
      baseQuery = {}
    }
    let resultList = []
    let size = 100
    let count = 0
    while (true) {
      // 組織の取得を呼び出す
      baseQuery.from = count
      baseQuery.size = size
      let result: SearchResult<Organization> = await fetchGet(BASE_URL + 'search' + toSearchQueryString(baseQuery))
      const resultCount = result.list.length
      if (resultCount > 0) {
        // 検索結果が存在した場合は戻り値に含める
        resultList.push(...result.list)
        if (size > resultCount) {
          // 指定のサイズよりも少なくとれた場合はページング不要
          break
        } else {
          // 指定のサイズよりも多くとれた場合はページングする
          count += resultCount
        }
      } else {
        break
      }
    }
    return resultList
  }

  //メンバー管理系

  function addAffilition(orgId: string, userId: string, role: UserRole) {
    return fetchPostForm(BASE_URL + orgId + '/add-affiliation', {
      userId,
      role,
    })
  }

  function updateRole(orgId: string, userId: string, role: UserRole) {
    return fetchPostForm(BASE_URL + orgId + '/update-role', { userId, role })
  }

  function removeAffilition(orgId: string, userId: string) {
    return fetchPostForm(BASE_URL + orgId + '/remove-affiliation', { userId })
  }

  function getOrganizationMemberSearch(
    orgId: string,
  ): (q: SearchQuery) => Promise<SearchResult<User>> {
    return (q: SearchQuery) => {
      return fetchGet(
        BASE_URL +
          orgId +
          '/search-organization-member' +
          toSearchQueryString(q),
      )
    }
  }

  return {
    getOrganization,
    participate,
    createProject,
    updateOrganization,
    authorizeOrganization,
    searchOrganization,
    searchOrganizationList,
    addAffilition,
    updateRole,
    removeAffilition,
    getOrganizationMemberSearch,
  }
}
